/** Formats API ISO dates for people while leaving already-human labels intact. */
const STRICT_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export function isStrictCalendarDate(value: unknown): value is string {
  if (typeof value !== 'string' || !STRICT_DATE_RE.test(value)) return false;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

export function formatHumanDate(value: string, options: { includeYear?: boolean } = {}): string {
  const match = /^(\d{4})-(\d{2})(?:-(\d{2}))?(?:T.*)?$/.exec(value);
  if (!match) return value;

  const [, year, month, day] = match;
  const parsed = new Date(Date.UTC(Number(year), Number(month) - 1, day ? Number(day) : 1));
  if (Number.isNaN(parsed.getTime())) return value;
  const monthLabel = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' }).format(parsed);
  if (!day) return `${monthLabel} '${year.slice(2)}`;
  const dayLabel = new Intl.DateTimeFormat('en-US', { day: 'numeric', timeZone: 'UTC' }).format(parsed);
  return `${monthLabel} ${dayLabel}${options.includeYear === false ? '' : `, ${year}`}`;
}
